<template>
  <b-card>
    <!-- TABLE -->

    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(no)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickDelete(data.index)"
            >{{ data.value.view }}DELETE</b-button
          >
        </span>
      </template>
    </b-table>
  </b-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
    onClickDelete(index) {
      this.$emit("delete", index);
    }
  }
};
</script>
<style lang="css" scoped></style>
